/* eslint-disable react/no-danger */
/**
 * Module dependencies.
 */

import { Button } from '@mui/material';
import { Company } from 'types/company';
import {
  CompanyDescription,
  CompanyTitle,
  Image,
  ImageWrapper,
  LinkAction,
  Wrapper,
} from './about-company.style';

import { FadeInUp } from 'components/atoms/in-view-once/fade-in-up';
import { InViewOnce } from 'components/atoms/in-view-once/in-view-once';
import { JSX, useMemo } from 'react';
import { getAsset } from 'utils/resolve-admin';
import { pageComponents } from 'constants/page-components';
import { useTranslation } from 'next-i18next';
import MarkdownIt from 'markdown-it';

/**
 * `Props` type.
 */

type Props = {
  company: Company;
};

/**
 * Md instance.
 */

const md = new MarkdownIt();

/**
 * Export `AboutCompany` component.
 */

export function AboutCompany({ company }: Props): JSX.Element {
  const [translate, i18n] = useTranslation();
  const { description } = useMemo(() => {
    const description =
      company.description[i18n.language] ??
      company.description[i18n.options.fallbackLng as string];

    return {
      description: md.render(description),
    };
  }, [company.description, i18n.language, i18n.options.fallbackLng]);

  return (
    <Wrapper>
      <ImageWrapper>
        <InViewOnce AnimationComponent={FadeInUp}>
          <Image
            alt={translate('home.aboutCompany.title')}
            src={getAsset(company.store.filename_disk)}
          />
        </InViewOnce>
      </ImageWrapper>

      <CompanyTitle>{translate('home.aboutCompany.title')}</CompanyTitle>

      <CompanyDescription component={'div'}>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </CompanyDescription>

      <LinkAction href={pageComponents.contacts}>
        <InViewOnce AnimationComponent={FadeInUp}>
          <Button color={'primary'} variant={'outlined'}>
            {translate('home.contactUsButton')}
          </Button>
        </InViewOnce>
      </LinkAction>
    </Wrapper>
  );
}
